import {
  Box,
  Button,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
  Divider,
  IconButton,
  Tooltip,
  useDisclosure,
  Alert,
  AlertIcon,
} from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import Logo from "../../assets/gopass-logo.png";
import { BiChevronDown } from "react-icons/bi";
import { getUser, isRepresentante, logout, MENSAGEM_PENDENCIA_FINANCEIRA_TOPO, refreshUser, shouldHideFeeDetails, temPendenciaFinanceira } from "../../libs/auth";
import { MenuItem as ItemMenu } from "./MenuItem";
import { MdOutlineMenu } from "react-icons/md";
import { MenuMobile } from "./MobileMenu";

function getAgenciaDisplayName(agencia?: { nome?: string; nome_fantasia?: string } | null) {
  const nomeFantasia = agencia?.nome_fantasia?.trim();

  if (nomeFantasia) {
    return nomeFantasia;
  }

  return agencia?.nome?.trim().split(/\s+/)[0];
}

export function Header() {
  const user = getUser();
  const representanteOnly = isRepresentante();
  const hideFeeDetails = shouldHideFeeDetails();

  const {onOpen, onClose,isOpen} = useDisclosure()

  const [name, sobrenome] = user.name.split(" ");
  const [nomeAgencia, setNomeAgencia] = useState<string | undefined>(
    getAgenciaDisplayName(user.agencia),
  );
  const [, setPerfilAtualizadoEm] = useState(0);

  useEffect(() => {
    let mounted = true;

    refreshUser()
      .then((perfil) => {
        if (!mounted || !perfil) {
          return;
        }

        setNomeAgencia(getAgenciaDisplayName(perfil.agencia));
        setPerfilAtualizadoEm(Date.now());
      });

    return () => {
      mounted = false;
    };
  }, []);

  async function handleLogout(){
    await logout();

    window.location.href = '/login';
  }

  return (
    <Box
      p={"1rem"}
      as="nav"
      bg={"white"}
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      mt={4}
      borderTopRadius={'md'}
    >
      {temPendenciaFinanceira() && (
        <Alert status="warning" mb={4} borderRadius="md">
          <AlertIcon />
          {MENSAGEM_PENDENCIA_FINANCEIRA_TOPO}
        </Alert>
      )}
      <Flex
        width={"100%"}
        flexDir={{
          xs: 'column',
          lg: 'row'
        }}
        justifyContent={"start"}
        align={"center"}
        gap={4}
      >
        <Button size={'lg'} variant={"unstyled"} onClick={() => Navigate({ to: "/" })}>
          <Image src={Logo} alt="logo gopass" />
        </Button>
        <Text fontWeight={'bold'} fontSize={{
          xs: 'sm',
          md: 'md'
        }}>GOPASS SISTEMA DE VENDA DE PASSAGENS DE ÔNIBUS</Text>
        {nomeAgencia && (
          <Tooltip label={nomeAgencia} hasArrow>
            <Text
              ml={{ xs: 0, lg: 'auto' }}
              mr={{ xs: 0, lg: 8 }}
              maxW={{ xs: '100%', lg: '360px' }}
              fontSize={{ xs: 'lg', md: 'xl' }}
              fontWeight="extrabold"
              color="blue.700"
              whiteSpace="nowrap"
              overflow="hidden"
              textOverflow="ellipsis"
            >
              {nomeAgencia}
            </Text>
          </Tooltip>
        )}
      </Flex>
      <Divider my={4} borderColor={'black'}/>
      <Flex display={{
        xs: 'none',
        lg: 'flex'
      }} flexDir={'row'} justifyContent={'end'} gap={4}>
        <Flex gap={8}>
          <ItemMenu title="Passagens" path="/home"/>
          {!representanteOnly && !hideFeeDetails && <ItemMenu title="Financeiro" path="/faturas" />}
          {representanteOnly && <ItemMenu title="Agências afiliadas" path="/agencias-afiliadas" />}
          <ItemMenu title="Relatório" path="/relatorio"/>
          {!representanteOnly && !hideFeeDetails && <ItemMenu title="Usuários" path="/usuarios" />}
          {!representanteOnly && !hideFeeDetails && <ItemMenu title="Movimentação Financeira" path="/movimentacao" />}
        </Flex>
        <Menu>
          <MenuButton
            variant={"outline"}
            borderColor={"black"}
            as={Button}
            rightIcon={<BiChevronDown />}
          >
            {name} {sobrenome}
          </MenuButton>
          <MenuList>
            <MenuItem onClick={handleLogout}>Sair</MenuItem>
          </MenuList>
        </Menu>
      </Flex>
      <IconButton w={'100%'} onClick={() => onOpen()} icon={<MdOutlineMenu />} aria-label="menu mobile" display={{
        xs: 'flex',
        lg: 'none'
      }} justifyContent={'center'}/>

      <MenuMobile isOpen={isOpen} onClose={onClose} />
      <Divider borderColor={'black'} my={4}/>
    </Box>
  );
}
